import ApiConnector from '@/models/ApiConnector';
import ApiModel     from '@widesk-core/models/ApiModel';
import config       from '@/config';

export const fondationsConnector = new ApiConnector({
	baseURL: config.api_endpoint + `/fondations`,
});

export default class FondationsServiceModel extends ApiModel {
	public static get connector() {
		return fondationsConnector;
	}

	public static serviceName = 'fondations';
	public static partitionName = 'jts';
}
